import { render, staticRenderFns } from "./ContestProjectListView.vue?vue&type=template&id=137319ca&scoped=true&"
import script from "./ContestProjectListView.vue?vue&type=script&lang=js&"
export * from "./ContestProjectListView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "137319ca",
  null
  
)

export default component.exports